'use strict';

/**
 * This file is responsible for wiring up the custom marketingCLoud events for cart abandon.
 * Where possible all will be contained here and glom on to custom events that get fired during cart interation
 */
const collectUtils = require('./marketingCloud/collectUtils');

function initCollectUtils() {
    if (collectUtils.mcEnabled) {
        window.collect = collectUtils.collectjs;
    }
}

function trackAddToCart() {
    if (collectUtils.mcEnabled) {
        $('body').on('product:afterAddToCart', function (e, data) {
            console.log(data);
            window.collect.trackCart();
        });
    }
}

function trackAddBonusProduct() {
    if (collectUtils.mcEnabled) {
        $('body').on('product:afterAddBonusProduct', function (e, data) {
            console.log("Tracking Bonus Product");
            window.collect.trackCart();
        });
    }
}

function trackCartUpdate() {
    // called when an item is removed... qty modified, or the edit product quickview is used
    if (collectUtils.mcEnabled) {
        $('body').on('cart:update', function (e, data) {
            console.log(data);
            window.collect.trackCart();
        });
    }
}

function trackSaveForLater() {
    // this handles when an item is savedForLater or added to cart from save for later
    if (collectUtils.mcEnabled) {
        $('body').on('cart:saveforlater:update', function (e, data) {
            console.log(data);
            window.collect.trackCart();
        })
    }
}

// bind to the event thrown in login/login.js
function registerSetUserInfo() {
    if (collectUtils.mcEnabled) {
        $('form.registration').on('login:register:success', function(e, data) {
            if(data && data.contactId) {
                window.collect.setUserInfo(data.contactId);
            }
            if (data && data.email) {
                window.collect.setUserInfo(data.email);
            }
        });
    }
}

// bind to the event thrown in login/login.js
function loginSetUserInfo() {
    if (collectUtils.mcEnabled) {
        $('form.login').on('login:success', function (e, data) {
            if(data && data.contactId) {
                window.collect.setUserInfo(data.contactId);
            }
        });
    }
}

// bind to the event thrown in emailSignup/emailSignup.js
function emailSignUpSetUserInfo() {
    if (collectUtils.mcEnabled) {
        $('body').on('emailsignup:success', function (e, data) {
            if(data && data.email) {
                window.collect.setUserInfo(data.email);
            }
        });
    }
}

module.exports = {
    initCollectUtils: initCollectUtils,
    trackAddToCart: trackAddToCart,
    trackAddBonusProduct: trackAddBonusProduct,
    trackCartUpdate: trackCartUpdate,
    trackSaveForLater: trackSaveForLater,
    loginSetUserInfo: loginSetUserInfo,
    registerSetUserInfo: registerSetUserInfo,
    emailSignUpSetUserInfo: emailSignUpSetUserInfo
};
